import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Observable } from 'rxjs';
import { ISideTabMenu } from './side-tab-template-helpers/side-tab-vm';
import { NgClass, NgComponentOutlet, AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
@Component({
  selector: 'app-side-tab-template',
  templateUrl: './side-tab-template.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, MatProgressSpinner, NgComponentOutlet, AsyncPipe],
})
export class SideTabTemplateComponent {
  @Input() public sideTabs$: Observable<ISideTabMenu[]>;
  @Input() public activeTab$: Observable<ISideTabMenu>;
  @Output() public tabClick = new EventEmitter<ISideTabMenu>();

  public onTabClick(details: ISideTabMenu): void {
    this.tabClick.emit(details);
  }
}
